<template>
  <div class="cart-container">
    <div class="main-content">
      <el-card shadow="never" class="cart-card">
        <div slot="header" class="card-header">
          <div class="header-title">
            <i class="el-icon-shopping-cart-2 header-icon" />
            <span>我的购物车</span>
            <span v-if="cartList.length" class="cart-count">（共 {{ cartList.length }} 件商品）</span>
          </div>
          <el-button v-if="cartList.length" type="text" class="clear-btn" @click="handleBatchDelete">
            清空已选
          </el-button>
        </div>

        <!-- 1. 购物车列表 -->
        <div v-loading="loading" class="cart-body">
          <div v-if="cartList.length === 0" class="empty-box">
            <el-empty description="购物车空空如也，去选购心仪的商品吧！" :image-size="140">
              <el-button type="primary" size="medium" @click="$router.push('/')">去逛逛</el-button>
            </el-empty>
          </div>

          <template v-else>
            <!-- 表头 -->
            <div class="cart-table-header">
              <el-checkbox v-model="isAllSelected" :indeterminate="isIndeterminate" @change="handleSelectAll">
                全选
              </el-checkbox>
              <span class="col-goods">商品信息</span>
              <span class="col-price">单价</span>
              <span class="col-num">数量</span>
              <span class="col-subtotal">小计</span>
              <span class="col-action">操作</span>
            </div>

            <!-- 商品列表项 -->
            <div v-for="item in cartList" :key="item.skuId" class="cart-item" :class="{ 'is-selected': item.selected }">
              <div class="col-select">
                <el-checkbox v-model="item.selected" @change="handleItemSelect" />
              </div>
              <div class="col-goods goods-info">
                <img :src="item.picUrl || defaultPic" class="goods-img" alt="商品图">
                <div class="goods-detail">
                  <div class="goods-title" :title="item.title">{{ item.title }}</div>
                  <div class="goods-sku">规格: <code>{{ item.skuId }}</code></div>
                </div>
              </div>
              <div class="col-price">
                <span class="price-num">￥{{ item.price }}</span>
              </div>
              <div class="col-num">
                <el-input-number
                  v-model="item.count"
                  :min="1"
                  :max="item.stock || 99"
                  size="mini"
                  @change="handleCountChange(item)"
                />
              </div>
              <div class="col-subtotal">
                <span class="subtotal-num">￥{{ (item.price * item.count).toFixed(2) }}</span>
              </div>
              <div class="col-action">
                <el-button type="text" icon="el-icon-delete" class="del-btn" @click="handleDelete(item)">删除</el-button>
              </div>
            </div>

            <!-- 2. 底部结算吸顶/悬浮栏 -->
            <div class="cart-footer">
              <div class="footer-left">
                <el-checkbox v-model="isAllSelected" :indeterminate="isIndeterminate" @change="handleSelectAll">
                  全选
                </el-checkbox>
                <el-button type="text" class="batch-del-btn" @click="handleBatchDelete">删除选中商品</el-button>
              </div>
              <div class="footer-right">
                <div class="total-info">
                  <span class="selected-text">已选择 <strong>{{ selectedCount }}</strong> 件商品</span>
                  <span class="total-label">合计：</span>
                  <span class="total-amount">￥{{ totalPrice }}</span>
                </div>
                <el-button
                  type="danger"
                  size="medium"
                  class="checkout-btn"
                  :disabled="selectedCount === 0"
                  @click="handleCheckout"
                >
                  去结算
                </el-button>
              </div>
            </div>
          </template>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cart',
  data() {
    return {
      text: '购物车',
      loading: false,
      isAllSelected: false,
      isIndeterminate: false,
      defaultPic: 'https://via.placeholder.com/80',
      cartList: [
        { skuId: 'SKU1001', title: '【秒杀专享】高性能云服务器 2核4G 10M带宽', price: '99.00', count: 1, stock: 10, selected: true, picUrl: '' },
        { skuId: 'SKU1002', title: '极客风机械键盘 108键红轴 RGB背光', price: '299.00', count: 2, stock: 5, selected: false, picUrl: '' }
      ]
    }
  },
  computed: {
    selectedCount() {
      return this.cartList.filter(item => item.selected).reduce((sum, item) => sum + item.count, 0)
    },
    totalPrice() {
      return this.cartList
        .filter(item => item.selected)
        .reduce((sum, item) => sum + item.price * item.count, 0)
        .toFixed(2)
    }
  },
  created() {
    document.title = this.text
    this.checkSelectStatus()
  },
  methods: {
    handleSelectAll(val) {
      this.cartList.forEach(item => { item.selected = val })
      this.isIndeterminate = false
    },
    handleItemSelect() {
      this.checkSelectStatus()
    },
    checkSelectStatus() {
      const checkedCount = this.cartList.filter(item => item.selected).length
      this.isAllSelected = checkedCount === this.cartList.length && this.cartList.length > 0
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cartList.length
    },
    handleCountChange(item) {
      // 触发数量更新事件
    },
    handleDelete(item) {
      this.$confirm('确定要从购物车中删除该商品吗？', '提示', { type: 'warning' }).then(() => {
        this.cartList = this.cartList.filter(i => i.skuId !== item.skuId)
        this.checkSelectStatus()
        this.$message.success('已移出购物车')
      }).catch(() => {})
    },
    handleBatchDelete() {
      const selectedItems = this.cartList.filter(i => i.selected)
      if (!selectedItems.length) {
        return this.$message.warning('请先勾选需要删除的商品')
      }
      this.$confirm(`确定要删除选中的 ${selectedItems.length} 项商品吗？`, '批量删除', { type: 'warning' }).then(() => {
        this.cartList = this.cartList.filter(i => !i.selected)
        this.checkSelectStatus()
        this.$message.success('删除成功')
      }).catch(() => {})
    },
    handleCheckout() {
      this.$router.push('/mall/order-pay')
    }
  }
}
</script>

<style scoped>
.cart-container {
  min-height: 100vh;
  background-color: #f8fafc;
  padding: 24px 0;
}

.main-content {
  max-width: 980px;
  margin: 0 auto;
  padding: 0 16px;
}

.cart-card {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-icon {
  color: #ef4444;
}

.cart-count {
  font-size: 13px;
  color: #64748b;
  font-weight: normal;
}

.clear-btn {
  color: #94a3b8;
}
.clear-btn:hover {
  color: #ef4444;
}

.empty-box {
  padding: 60px 0;
}

.cart-table-header {
  display: flex;
  align-items: center;
  background-color: #f8fafc;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 13px;
  color: #64748b;
  margin-bottom: 12px;
}

.col-goods { flex: 3; margin-left: 12px; }
.col-price { flex: 1; text-align: center; }
.col-num { flex: 1.2; text-align: center; }
.col-subtotal { flex: 1; text-align: center; }
.col-action { width: 80px; text-align: center; }

.cart-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border: 1px solid #f1f5f9;
  border-radius: 8px;
  margin-bottom: 12px;
  background-color: #fff;
  transition: all 0.2s ease;
}

.cart-item:hover, .cart-item.is-selected {
  border-color: #fca5a5;
  background-color: #fffdfd;
}

.goods-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.goods-img {
  width: 64px;
  height: 64px;
  border-radius: 6px;
  object-fit: cover;
  border: 1px solid #f1f5f9;
}

.goods-title {
  font-size: 14px;
  color: #1e293b;
  font-weight: 600;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.goods-sku {
  font-size: 12px;
  color: #94a3b8;
}

.goods-sku code {
  background: #f1f5f9;
  padding: 1px 4px;
  border-radius: 3px;
}

.price-num {
  font-size: 14px;
  color: #475569;
}

.subtotal-num {
  font-size: 15px;
  color: #ef4444;
  font-weight: 700;
}

.del-btn {
  color: #94a3b8;
}
.del-btn:hover {
  color: #ef4444;
}

.cart-footer {
  margin-top: 20px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.03);
}

.footer-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.batch-del-btn {
  color: #64748b;
  font-size: 13px;
}
.batch-del-btn:hover {
  color: #ef4444;
}

.footer-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.total-info {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 13px;
  color: #64748b;
}

.selected-text strong {
  color: #ef4444;
}

.total-label {
  margin-left: 8px;
  color: #1e293b;
}

.total-amount {
  font-size: 22px;
  color: #ef4444;
  font-weight: 800;
}

.checkout-btn {
  background-color: #ef4444;
  border-color: #ef4444;
  font-weight: 600;
  padding: 10px 28px;
  border-radius: 6px;
}
.checkout-btn:hover {
  background-color: #dc2626;
  border-color: #dc2626;
}
</style>
